import { useMemo } from 'react';
import { ColumnGroup } from 'react-table';

import { CheckMark } from 'components/CheckMark';

import { TableActions } from './components/TableActions';

export type UserRow = {
  email: string;
  name: string;
  last_name: string;
  view_price: boolean;
  view_distributor_price: boolean;
  view_inactive_items: boolean;
  insert_order: boolean;
  view_order: boolean;
  distributor: boolean;
  insert_budget: boolean;
  id: string;
};

const pickUserColumns = (modifyUserPermissions: Function, isUpdating?: boolean) =>
  useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Users',
        columns: [
          {
            Header: 'Email',
            accessor: 'email',
          },
          {
            Header: 'Name',
            accessor: 'name',
          },
          {
            Header: 'Last Name',
            accessor: 'last_name',
          },
          {
            Header: 'Price',
            accessor: 'view_price',
            Cell: (cell) => (
              <CheckMark
                disabled={isUpdating}
                onClick={() => modifyUserPermissions(cell)}
                isChecked={cell.value}
              />
            ),
          },
          {
            // accessor upper-cased is the permission name (VIEW_DISTRIBUTOR_PRICE),
            // see modifyUserPermissions in List.hooks.ts.
            Header: 'View Distributor Price',
            accessor: 'view_distributor_price',
            Cell: (cell) => (
              <CheckMark
                disabled={isUpdating}
                onClick={() => modifyUserPermissions(cell)}
                isChecked={cell.value}
              />
            ),
          },
          {
            Header: 'Inactive products',
            accessor: 'view_inactive_items',
            Cell: (cell) => (
              <CheckMark
                disabled={isUpdating}
                onClick={() => modifyUserPermissions(cell)}
                isChecked={cell.value}
              />
            ),
          },
          {
            Header: 'Orders',
            accessor: 'insert_order',
            Cell: (cell) => (
              <CheckMark
                disabled={isUpdating}
                onClick={() => modifyUserPermissions(cell)}
                isChecked={cell.value}
              />
            ),
          },
          {
            Header: 'Reading orders',
            accessor: 'view_order',
            Cell: (cell) => (
              <CheckMark
                disabled={isUpdating}
                onClick={() => modifyUserPermissions(cell)}
                isChecked={cell.value}
              />
            ),
          },
          {
            Header: 'Distributor',
            accessor: 'distributor',
            Cell: (cell) => (
              <CheckMark
                disabled={isUpdating}
                onClick={() => modifyUserPermissions(cell)}
                isChecked={cell.value}
              />
            ),
          },
          {
            Header: 'Budget',
            accessor: 'insert_budget',
            Cell: (cell) => (
              <CheckMark
                disabled={isUpdating}
                onClick={() => modifyUserPermissions(cell)}
                isChecked={cell.value}
              />
            ),
          },
          {
            Header: 'Actions',
            accessor: 'id',
            disableSortBy: true,
            Cell: ({ row }) => <TableActions row={row} />,
          },
        ],
      },
    ],
    [isUpdating]
  );

export { pickUserColumns };
